/**
 * App bar breadcrumbs for Inference pages.
 */

import {MODEL_INDEX} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/inference/modelInfo';
import React, {type FC, memo, useMemo} from 'react';

import {INFERENCE_PATH} from '../../../../routes/inference/inferencePaths';
import {isMountedInShell} from '../../../../shellRemote';
import Breadcrumbs, {type BreadcrumbPart} from '../../../Breadcrumbs';

export type NavBreadcrumbsInferenceProps = {
  collectionId?: string;
  modelId?: string;
};

export function useNavBreadcrumbsInferenceParts(
  params: NavBreadcrumbsInferenceProps
): BreadcrumbPart[] {
  const {modelId} = params;

  const parts: BreadcrumbPart[] = useMemo(
    () => [
      ...(!isMountedInShell()
        ? [
            {
              label: 'Serverless Inference',
              to: INFERENCE_PATH,
            },
          ]
        : []),
      ...(modelId != null
        ? [
            {
              label: MODEL_INDEX[modelId]?.label ?? modelId,
            },
          ]
        : []),
    ],
    [modelId]
  );

  return parts;
}

const NavBreadcrumbsInferenceComp: FC<
  NavBreadcrumbsInferenceProps
> = params => {
  const parts = useNavBreadcrumbsInferenceParts(params);
  return <Breadcrumbs parts={parts} />;
};

const NavBreadcrumbsInference = memo(NavBreadcrumbsInferenceComp);

export default NavBreadcrumbsInference;
